export enum ToastSeverity {
    DANGER = "DANGER",
    SUCCESS = "SUCCESS",
    DEFAULT = "DEFAULT",
}
export interface Toast {

    severity: ToastSeverity;
    text: string;
}
